/*
Defines the custom element <ravel-switch>
*/

import { RavelSwitch } from './src/RavelSwitch.js';

customElements.define('ravel-switch', RavelSwitch);
